export default "__VITE_ASSET__979ef815__"